<template>
    <BarometerJob />
</template>
<script setup lang="ts">
    import BarometerJob from '~/components/barometer/job/BarometerJob.vue';
</script>
